export enum AssetSelectionTypeEnum {
  AllLockedIn = 2,
  AllNonLockedIn = 3,
  SpecifyAmount = 4
}
